import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import isEmailValid from '../../../../../utils/isEmailValid';
import { EmailsObjectType } from '../../types';

export default function useRoutingAcceptedEmails() {
  const [addRoutingEmailModalShow, setAddRoutingEmailModalShow] = useState(false);
  const [removeRoutingEmailModalShow, setRemoveRoutingEmailModalShow] = useState(false);
  const [routingEmails, setRoutingEmails] = useState<EmailsObjectType[]>([]);
  const [routingEmailToAdd, setRoutingEmailToAdd] = useState('');
  const [routingEmailToRemove, setRoutingEmailToRemove] = useState('');
  const [originalRoutingEmails, setOriginalRoutingEmails] = useState<EmailsObjectType[]>([]);
  const [routingEmailOwnerNameToAdd, setRoutingEmailOwnerNameToAdd] = useState('');

  const hasOriginalRoutingEmailsChanged = useMemo((() => JSON.stringify(originalRoutingEmails) !== JSON.stringify(routingEmails)), [originalRoutingEmails, routingEmails]);
  const hasRoutingEmailsToBeRendered = useMemo((() => routingEmails.length > 0), [routingEmails]);

  function handleRoutingEmailToAddChange(event: ChangeEvent<HTMLInputElement>) {
    setRoutingEmailToAdd(event.target.value);
  }

  function handleRoutingEmailOwnerNameToAddChange(event: ChangeEvent<HTMLInputElement>) {
    setRoutingEmailOwnerNameToAdd(event.target.value);
  }

  const addRoutingEmail = useCallback(() => {
    const onlyEmails = routingEmails.map((emailObj) => emailObj.email);
    const doesEmailAlreadyExists = onlyEmails.includes(routingEmailToAdd);
    if (doesEmailAlreadyExists) {
      toast.warn('Este e-mail já foi adicionado!');
      return;
    }
    if (!isEmailValid(routingEmailToAdd)) {
      toast.warn('E-mail inválido!');
      return;
    }
    setRoutingEmails((prevState) => [...prevState, { email: routingEmailToAdd, emailOwnerName: routingEmailOwnerNameToAdd }]);
    setRoutingEmailToAdd('');
    setRoutingEmailOwnerNameToAdd('');
    toast.success('E-mail adicionado. Não se esqueça de salvar as alterações para confirmar');
  }, [routingEmailOwnerNameToAdd, routingEmailToAdd, routingEmails]);

  const removeRoutingEmail = useCallback(() => {
    const filteredEmails = routingEmails.filter((email) => email.email !== routingEmailToRemove);
    setRoutingEmails(filteredEmails);
    setRemoveRoutingEmailModalShow(false);
    toast.success('E-mail removido. Não esqueça de salvar as configurações para aplicar as mudanças!');
    setRoutingEmailToRemove('');
  }, [routingEmailToRemove, routingEmails]);

  const resetRoutingEmails = useCallback(() => {
    setRoutingEmails(originalRoutingEmails);
    toast.info('Suas alterações foram desfeitas');
  }, [originalRoutingEmails]);

  return {
    setAddRoutingEmailModalShow,
    hasRoutingEmailsToBeRendered,
    routingEmails,
    setRoutingEmails,
    setRoutingEmailToRemove,
    setRemoveRoutingEmailModalShow,
    routingEmailToRemove,
    removeRoutingEmail,
    addRoutingEmailModalShow,
    routingEmailToAdd,
    handleRoutingEmailToAddChange,
    addRoutingEmail,
    removeRoutingEmailModalShow,
    resetRoutingEmails,
    hasOriginalRoutingEmailsChanged,
    setOriginalRoutingEmails,
    routingEmailOwnerNameToAdd,
    handleRoutingEmailOwnerNameToAddChange,
  };
}
